import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  Container,
  useTheme,
  Grid,
  Stack,
  Tooltip,
  MenuItem,
  ListItemIcon,
  Chip,
  Paper,
  Tab,
  Tabs,
  Skeleton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ChecklistIcon from "@mui/icons-material/Checklist";
import { UrlApi } from "../../../../services/apirest";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import CloseIcon from "@mui/icons-material/Close";
import DetallePedidos from "./DetallePedidos";
import { verEnviarPDF, verEnviarPDFenvasado } from "../../../../services/services";
import AnularFactura from "../../facturados/anularFactura/AnularFactura";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import BlockIcon from "@mui/icons-material/Block";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PhoneIcon from "@mui/icons-material/Phone";
import moment from "moment/moment";
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import AnularEntregaRemito from "./accionesRemito/AnularEntregaRemito";
import EdicionEntregaRemito from "./accionesRemito/EdicionEntregaRemito";

const PedidosHojasTable = ({ row, onBack }) => {
  const theme = useTheme();
  const [pedidosTelefonista, setPedidosTelefonista] = useState([]);
  const [clientesHojaRuta, setClientesHojaRuta] = useState([]);
  const [anularFactura, setAnularFactura] = useState(false);
  const [rowFactura, setRowFactura] = useState();
  const [tabActual, setTabActual] = useState(0);
  const esRuta = row.hoja_ruta;
  const rol = localStorage.getItem("role")
  const sector = parseInt(localStorage.getItem("sector"))
  const [editarEntrega, setEditarEntrega] = useState(false)
  const [anularEntrega, setAnularEntrega] = useState(false)
  // loading: hay un fetch en curso. cargaInicial: todavía no llegó la primera respuesta (muestra skeleton)
  const [loading, setLoading] = useState(true)
  const [cargaInicial, setCargaInicial] = useState(true)

  const fetchJson = async (ruta) => {
    const response = await fetch(UrlApi + ruta);
    if (!response.ok) {
      throw new Error(`Error ${response.status} en ${ruta}`);
    }
    return response.json();
  };

  const obtenerDatosCompletos = async () => {
    setLoading(true);
    try {
      if (row.hoja_ruta === null) {
        // Solo pedidos de telefonista
        const data = await fetchJson("/envasado_pedidos/xrendicion/" + row.uuid);
        const pedidosConOrigen = data.map(pedido => ({
          ...pedido,
          origen: 'Telefonista'  // Agregar origen
        }));
        setPedidosTelefonista(pedidosConOrigen);
      } else {
        const [pedidosRaw, ventasData, clientesData] = await Promise.all([
          fetchJson("/envasado_pedidos/xrendicion/" + row.uuid),
          // Ventas de hoja de ruta (clientes visitados)
          fetchJson("/envasado_ventas_hoja/xrend/" + row.id),
          // Clientes de hoja de ruta (todos los asignados)
          fetchJson("/envasado_rendiciones/hojas/" + row.uuid),
        ]);
        const pedidosData = pedidosRaw.map(pedido => ({
          ...pedido,
          origen: 'Telefonista'
        }));

        const idsVentasHojaRuta = new Set();
        ventasData.forEach(venta => {
          if (venta.id) {
            idsVentasHojaRuta.add(venta.id);
          }
        });

        const pedidosTelefonistaFiltrados = pedidosData.filter(pedido => {
          return !idsVentasHojaRuta.has(pedido.id);
        });

        setPedidosTelefonista(pedidosTelefonistaFiltrados);
        
        // Combinar clientes de hoja de ruta incluyendo los pedidos que coinciden
        const clientesCombinados = combinarClientesHojaRuta(pedidosData, ventasData, clientesData, idsVentasHojaRuta);
        setClientesHojaRuta(clientesCombinados);
      }
    } catch (error) {
      console.error("Error al obtener pedidos de la rendición:", error);
    } finally {
      setLoading(false);
      setCargaInicial(false);
    }
  };

  const combinarClientesHojaRuta = (pedidosData, ventasData, clientesData, idsVentasHojaRuta) => {
    const resultado = [];
    const clientesProcesados = new Set();

    ventasData.forEach(venta => {
      const clave = `${venta.cliente}_${venta.direccion_entrega}`;
      if (!clientesProcesados.has(clave)) {
        // Buscar si hay un pedido con el mismo ID para combinar datos
        const pedidoCorrespondiente = pedidosData.find(pedido => pedido.id === venta.id);
        
        resultado.push({
          ...venta,
          ...(pedidoCorrespondiente && {
            // Si hay pedido correspondiente, mantener los datos de la venta pero actualizar estado del pedido
            valor: pedidoCorrespondiente.valor,
            estado: pedidoCorrespondiente.estado,
            producto: pedidoCorrespondiente.producto || venta.producto,
            fecha_para: pedidoCorrespondiente.fecha_para || venta.fecha_para
          }),
          tipo: venta.vendio === 1 ? 'comprado' : 'no_comprado',
          estado_visita: venta.vendio === 1 ? 'Venta' : 'No Compró',
          origen: 'Hoja de Ruta'
        });
        clientesProcesados.add(clave);
      }
    });

    // Agregar pedidos que coinciden con IDs de ventas pero no están en ventasData
    pedidosData.forEach(pedido => {
      if (idsVentasHojaRuta.has(pedido.id)) {
        const clave = `${pedido.cliente}_${pedido.direccion_entrega}`;
        // Verificar si ya fue agregado desde ventasData
        const yaAgregado = Array.from(clientesProcesados).some(claveProcesada => 
          claveProcesada === clave
        );
        
        if (!yaAgregado) {
          resultado.push({
            ...pedido,
            tipo: 'comprado', 
            estado_visita: 'Comprado',
            vendio: 1,
            origen: 'Hoja de Ruta'
          });
          clientesProcesados.add(clave);
        }
      }
    });

    // Luego agregar clientes pendientes de visitar
    clientesData.forEach(cliente => {
      const clave = `${cliente.cliente}_${cliente.direccion_entrega}`;
      if (!clientesProcesados.has(clave)) {
        resultado.push({
          ...cliente,
          tipo: 'pendiente',
          estado_visita: 'Pendiente',
          vendio: null,
          valor: 'Pendiente',
          producto: '--',
          fecha_para: '-',
          origen: 'Hoja de Ruta'
        });
        clientesProcesados.add(clave);
      }
    });

    return resultado;
  };

  useEffect(() => {
    obtenerDatosCompletos();
  }, []);

  const handleCloseAnular = () => {
    setAnularFactura(false);
    obtenerDatosCompletos();
  };

  const handleCloseAnularEntregaRemito = () => {
    setAnularEntrega(false);
    obtenerDatosCompletos();
  };

  const handleCloseEditarEntrega = () => {
    setEditarEntrega(false);
    obtenerDatosCompletos();
  };

  const handleAnularFactura = (row) => {
    setAnularFactura(true);
    setRowFactura(row);
  };

  const handleAnularEntregaRemito = (row) => {
    setAnularEntrega(true);
    setRowFactura(row);
  };

  const handleEditarEntregaRemito = (row) => {
    setEditarEntrega(true);
    setRowFactura(row);
  };

  const handleChangeTab = (event, nuevoValor) => {
    setTabActual(nuevoValor);
  };

  // Columnas para Telefonista
  const columnsTelefonista = [
    {
      accessorKey: "id",
      header: "N° Pedido",
      size: 100,
      muiTableBodyCellProps: {
        align: "right",
      },
    },
    {
      accessorKey: "cliente",
      header: "Cliente",
      size: 150,
    },
    {
      accessorKey: "direccion_entrega",
      header: "Dirección",
    },
    {
      accessorKey: "fecha_para",
      header: "Fecha",
      size: 120,
      muiTableBodyCellProps: {
        align: "right",
      },
    },
    {
      accessorKey: "valor",
      header: "Estado",
      size: 120,
      Cell: ({ cell, row }) => {
        const backgroundColor = getEstadoColor(row.original.estado);
        return (
          <Typography
            sx={{
              backgroundColor,
              px: 1,
              borderRadius: "4px",
            }}
          >
            {cell.getValue() || "N/A"}
          </Typography>
        );
      },
    },
    // {
    //   accessorKey: "producto",
    //   header: "Productos",
    //   size: 200,
    // },
  ];

  // Columnas para Hoja de Ruta
  const columnsHojaRuta = [
    {
      accessorKey: "id",
      header: "N° Pedido",
      size: 100,
      Cell: ({ row }) => {
        if (row.original.tipo === 'pendiente') {
          return "-";
        }
        return row.original.id || "-";
      },
      muiTableBodyCellProps: {
        align: "right",
      },
    },
    {
      accessorKey: "cliente",
      header: "Cliente",
      size: 150,
    },
    {
      accessorKey: "direccion_entrega",
      header: "Dirección",
    },
    {
  accessorKey: "fecha_para",
  header: "Fecha",
  size: 120,
  Cell: ({ row }) => {
    // Si el cliente no compró, mostrar created_at en lugar de fecha_para
    if (row.original.tipo === 'no_comprado') {
      return moment(row.original.created_at).format("DD-MM-YYYY HH:MM") || "";
    }
    // Para clientes que compraron o están pendientes, mostrar fecha_para
    return row.original.fecha_para || "";
  },
  muiTableBodyCellProps: {
    align: "right",
  },
},
    {
      accessorKey: "estado_visita",
      header: "Resultado",
      size: 120,
      Cell: ({ row }) => {
        const estado = row.original.estado_visita;
        let color = 'default';
        
        switch(row.original.tipo) {
          case 'comprado':
            color = 'success';
            break;
          case 'no_comprado':
            color = 'warning';
            break;
          case 'pendiente':
            color = 'default';
            break;
        }

        return (
          <Chip 
            label={estado} 
            color={color}
            size="small"
            variant={row.original.tipo === 'pendiente' ? "outlined" : "filled"}
          />
        );
      },
    },
    {
      accessorKey: "valor",
      header: "Estado Pedido",
      size: 120,
      Cell: ({ row }) => {
        if (row.original.tipo === 'pendiente' || row.original.tipo === 'no_comprado') {
          return "-";
        }
        const backgroundColor = getEstadoColor(row.original.estado);
        return (
          <Typography
            sx={{
              backgroundColor,
              px: 1,
              borderRadius: "4px",
              fontSize: '0.875rem',
            }}
          >
            {row.original.valor || "-"}
          </Typography>
        );
      },
    },
    // {
    //   accessorKey: "producto",
    //   header: "Productos",
    //   size: 200,
    //   Cell: ({ row }) => row.original.producto || "--",
    // },
  ];

  const getEstadoColor = (estado) => {
    switch (estado) {
      case 246:
        return "#ffff88"; // Amarillo - Pendiente
      case 251:
        return "#e2e2e2"; // Gris - Aceptado
      case 252:
        return "#acec98"; // Verde - En Camino
      case 253:
        return "#82ddfc"; // Azul - En Puerta
      case 255:
        return "#F28B82"; // Rojo - Anulado
      default:
        return undefined;
    }
  };

  const getFilaColorHojaRuta = (row) => {
    switch(row.original.tipo) {
      case 'comprado':
        return getEstadoColor(row.original.estado) || '#f0f8ff';
      case 'no_comprado':
        return '#FFF9DB'; // Amarillo claro para no compró
      case 'pendiente':
        return '#F5F5F5'; // Gris claro para pendientes
      default:
        return undefined;
    }
  };

  const initialState = {
    density: "compact",
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const customLocalization = {
    ...MRT_Localization_ES,
    noRecordsToDisplay: "No hay registros disponibles",
  };

  // Renderizar tabla de Telefonista
  const renderTablaTelefonista = () => (
    <Box>
      {pedidosTelefonista.length > 0 ? (
        <MaterialReactTable
          columns={columnsTelefonista}
          data={pedidosTelefonista}
          layoutMode="grid"
          initialState={initialState}
          enableColumnActions={false}
          enableGlobalFilterModes={false}
          enableHiding={false}
          enableGrouping={true}
          enablePinning={true}
          enableColumnFilters={false}
          enableFullScreenToggle={false}
          positionActionsColumn="last"
          enableExpandAll={false}
          localization={customLocalization}
          state={{ showProgressBars: loading }}
          enableToolbarInternalActions={false}
          muiTableHeadCellProps={tableHeadCellProps}
          enableDensityToggle={false}
          enableColumnResizing={true}
          enableRowActions
          muiSearchTextFieldProps={muiSearchTextFieldProps}
          muiTableBodyRowProps={({ row }) => ({
            sx: {
              backgroundColor: getEstadoColor(row.original.estado),
            },
          })}
          muiTableBodyCellProps={{
            align: "left",
          }}
          renderDetailPanel={({ row }) => (
            <DetallePedidos row={row.original} hoja_ruta={false} />
          )}
          renderRowActions={({ row }) => (
            <Box sx={{ display: "flex", gap: "4px" }}>
              {[311, 312, 328, 355, 364].includes(row.original.estado) && (
                <Tooltip title="Ver Factura" placement="top">
                  <IconButton
                    onClick={() => verEnviarPDFenvasado(row.original.id_factura, 0)}
                  >
                    <RemoveRedEyeIcon color="primary" />
                  </IconButton>
                </Tooltip>
              )}

              {[328, 364].includes(row.original.estado) && (
                <Tooltip title="Ver Nota de Credito" placement="bottom">
                  <IconButton
                    onClick={() => verEnviarPDFenvasado(row.original.id_nc, 0)}
                  >
                    <VisibilityOffIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}

              {(row.original.estado === 311 || row.original.estado === 312) && (
                <Tooltip title="Anular Factura" placement="bottom">
                  <IconButton
                    onClick={() => handleAnularFactura(row.original)}
                  >
                    <BlockIcon color="error" />
                  </IconButton>
                </Tooltip>
              )}

              {(sector === 5 && row.original.estado === 354) && (
                <>
                <Tooltip title="Anular Entrega con Remito" placement="bottom">
                  <IconButton
                    onClick={() => handleAnularEntregaRemito(row.original)}
                  >
                    <AssignmentLateIcon color="error" />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Editar Entrega con remito " placement="bottom">
                  <IconButton
                    onClick={() => handleEditarEntregaRemito(row.original)}
                  >
                    <BorderColorIcon color="primary" />
                  </IconButton>
                </Tooltip>
                </>
              )}
            </Box>
          )}
        />
      ) : (
        <Box p={3} textAlign="center">
          <Typography color="textSecondary">
            No hay pedidos de telefonista
          </Typography>
        </Box>
      )}
    </Box>
  );

  // Renderizar tabla de Hoja de Ruta  
  const renderTablaHojaRuta = () => (
    <Box>
      {clientesHojaRuta.length > 0 ? (
        <MaterialReactTable
          columns={columnsHojaRuta}
          data={clientesHojaRuta}
          layoutMode="grid"
          initialState={initialState}
          enableColumnActions={false}
          enableGlobalFilterModes={false}
          enableHiding={false}
          enableGrouping={true}
          enablePinning={true}
          enableColumnFilters={false}
          enableFullScreenToggle={false}
          positionActionsColumn="last"
          enableExpandAll={false}
          localization={customLocalization}
          state={{ showProgressBars: loading }}
          enableToolbarInternalActions={false}
          muiTableHeadCellProps={tableHeadCellProps}
          enableDensityToggle={false}
          enableColumnResizing={true}
          enableRowActions
          muiSearchTextFieldProps={muiSearchTextFieldProps}
          muiTableBodyRowProps={({ row }) => ({
            sx: {
              backgroundColor: getFilaColorHojaRuta(row),
            },
          })}
          muiTableBodyCellProps={{
            align: "left",
          }}
          renderDetailPanel={({ row }) => (
            <DetallePedidos row={row.original} hoja_ruta={true} />
          )}
          renderRowActions={({ row }) => {
            // Solo mostrar acciones para clientes que compraron
            if (row.original.tipo !== 'comprado') {
              return null;
            }

            return (
              <Box sx={{ display: "flex", gap: "4px" }}>
                {[311, 312, 328, 355, 364].includes(row.original.estado) && (
                  <Tooltip title="Ver Factura" placement="top">
                    <IconButton
                      onClick={() => verEnviarPDFenvasado(row.original.id_factura, 0)}
                    >
                      <RemoveRedEyeIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                )}

                {[328, 364].includes(row.original.estado) && (
                  <Tooltip title="Ver Nota de Credito" placement="bottom">
                    <IconButton
                      onClick={() => verEnviarPDFenvasado(row.original.id_nc, 0)}
                    >
                      <VisibilityOffIcon color="secondary" />
                    </IconButton>
                  </Tooltip>
                )}

                {(row.original.estado === 311 || row.original.estado === 312) && (
                  <Tooltip title="Anular Factura" placement="bottom">
                    <IconButton
                      onClick={() => handleAnularFactura(row.original)}
                    >
                      <BlockIcon color="error" />
                    </IconButton>
                  </Tooltip>
                )}
                  {(sector === 5 && row.original.estado === 354) && (
                <>
                <Tooltip title="Anular Entrega con Remito" placement="bottom">
                  <IconButton
                    onClick={() => handleAnularEntregaRemito(row.original)}
                  >
                    <AssignmentLateIcon color="error" />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Editar Entrega con remito " placement="bottom">
                  <IconButton
                    onClick={() => handleEditarEntregaRemito(row.original)}
                  >
                    <BorderColorIcon color="primary" />
                  </IconButton>
                </Tooltip>
                </>
              )}
              </Box>
            );
          }}
        />
      ) : (
        <Box p={3} textAlign="center">
          <Typography color="textSecondary">
            No hay clientes en la hoja de ruta
          </Typography>
        </Box>
      )}
    </Box>
  );

  // Renderizar tabla única para cuando no es hoja de ruta
  const renderTablaUnica = () => (
    <MaterialReactTable
      columns={columnsTelefonista}
      data={pedidosTelefonista}
      layoutMode="grid"
      initialState={initialState}
      enableColumnActions={false}
      enableGlobalFilterModes={false}
      enableHiding={false}
      enableGrouping={true}
      enablePinning={true}
      enableColumnFilters={false}
      enableFullScreenToggle={false}
      positionActionsColumn="last"
      enableExpandAll={false}
      localization={customLocalization}
      state={{ showProgressBars: loading }}
      enableToolbarInternalActions={true}
      muiTableHeadCellProps={tableHeadCellProps}
      enableDensityToggle={false}
      enableColumnResizing={true}
      enableRowActions
      muiSearchTextFieldProps={muiSearchTextFieldProps}
      muiTableBodyRowProps={({ row }) => ({
        sx: {
          backgroundColor: getEstadoColor(row.original.estado),
        },
      })}
      muiTableBodyCellProps={{
        align: "left",
      }}
      renderDetailPanel={({ row }) => (
        <DetallePedidos row={row.original} hoja_ruta={false} />
      )}
      renderTopToolbarCustomActions={() => (
        <Typography variant="poster" fontSize={26}>
          <ChecklistIcon sx={{ fontSize: 20, mr: 1 }} />
          Pedidos
        </Typography>
      )}
      renderRowActions={({ row }) => (
        <Box sx={{ display: "flex", gap: "4px" }}>
          {[311, 312, 328, 355, 364].includes(row.original.estado) && (
            <Tooltip title="Ver Factura" placement="top">
              <IconButton
                onClick={() => verEnviarPDFenvasado(row.original.id_factura, 0)}
              >
                <RemoveRedEyeIcon color="primary" />
              </IconButton>
            </Tooltip>
          )}

          {[328, 364].includes(row.original.estado) && (
            <Tooltip title="Ver Nota de Credito" placement="bottom">
              <IconButton
                onClick={() => verEnviarPDFenvasado(row.original.id_nc, 0)}
              >
                <VisibilityOffIcon color="secondary" />
              </IconButton>
            </Tooltip>
          )}

          {(row.original.estado === 311 || row.original.estado === 312) && (
            <Tooltip title="Anular Factura" placement="bottom">
              <IconButton
                onClick={() => handleAnularFactura(row.original)}
              >
                <BlockIcon color="error" />
              </IconButton>
            </Tooltip>
          )}

            {(sector === 5 && row.original.estado === 354) && (
                <>
                <Tooltip title="Anular Entrega con Remito" placement="bottom">
                  <IconButton
                    onClick={() => handleAnularEntregaRemito(row.original)}
                  >
                    <AssignmentLateIcon color="error" />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Editar Entrega con remito " placement="bottom">
                  <IconButton
                    onClick={() => handleEditarEntregaRemito(row.original)}
                  >
                    <BorderColorIcon color="primary" />
                  </IconButton>
                </Tooltip>
                </>
              )}
        </Box>
      )}
    />
  );

  // Tabs para hoja de ruta
  const tabsHojaRuta = [
    {
      label: `Telefonista (${pedidosTelefonista.length})`,
      icon: <PhoneIcon />,
      content: renderTablaTelefonista()
    },
    {
      label: `Hoja de Ruta (${clientesHojaRuta.length})`,
      icon: <LocalShippingIcon />,
      content: renderTablaHojaRuta()
    }
  ];

  return (
    <div>
      <AppBar
        sx={{ position: "relative" }}
        style={{ backgroundColor: "#0979b0" }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onBack}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Pedidos de la Rendición {row.nro_rendicion}
          </Typography>
        </Toolbar>
      </AppBar>
      
      <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 1 }}>
        {cargaInicial ? (
          <Box sx={{ p: 3 }}>
            <Stack spacing={2}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={56}
                animation="wave"
              />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={500}
                animation="wave"
              />
            </Stack>
          </Box>
        ) : row.hoja_ruta !== null ? (
          <Box>
            <Tabs
              value={tabActual}
              onChange={handleChangeTab}
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                mb: 2
              }}
            >
              {tabsHojaRuta.map((tab, index) => (
                <Tab
                  key={index}
                  icon={tab.icon}
                  iconPosition="start"
                  label={tab.label}
                  sx={{
                    minHeight: 60,
                    '&.Mui-selected': {
                      backgroundColor: theme.palette.action.selected,
                    }
                  }}
                />
              ))}
            </Tabs>
            
            <Box>
              {tabsHojaRuta[tabActual].content}
            </Box>
          </Box>
        ) : (
          renderTablaUnica()
        )}

        {anularFactura && (
          <AnularFactura
            open={anularFactura}
            setOpen={setAnularFactura}
            factura={rowFactura}
            onClose={handleCloseAnular}
          />
        )}

        {anularEntrega && (
          <AnularEntregaRemito
            open={anularEntrega}
            setOpen={setAnularEntrega}
            factura={rowFactura}
            onClose={handleCloseAnularEntregaRemito}
          />
        )}
        {editarEntrega && (
          <EdicionEntregaRemito
            open={editarEntrega}
            setOpen={setEditarEntrega}
            factura={rowFactura}
            onClose={handleCloseEditarEntrega}
          />
        )}

      </Container>
    </div>
  );
};

export default PedidosHojasTable;